module.exports = __webpack_public_path__ + "img/9_69.56d3ced4.png";